var _rect, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortalsCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mortalsGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4834d4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#130f40",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 8,
    fill: "url(#mortalsGrad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 95,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "MORTALS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    fill: "white"
  }, "WARRIYO feat.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 135,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    fill: "white"
  }, "LAURA BREHM")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 155,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    textAnchor: "middle",
    fill: "white"
  }, "NCS RELEASE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortalsCover);
export default __webpack_public_path__ + "static/media/mortals-cover.50dddbc95905c7a50a3b8b5a2be8df2a.svg";
export { ForwardRef as ReactComponent };